import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';

/**
 * @summary Test
 *  */
@Component({
    selector: 'ea-popover-confirm',
    templateUrl: './ea-popover-confirm.component.html',
    styleUrls: ['./ea-popover-confirm.component.scss'],
    standalone: false
})
export class EaPopoverConfirmComponent implements OnInit {
  @Output() confirm: EventEmitter<any> = new EventEmitter();
  @Output() cancel: EventEmitter<any> = new EventEmitter();
  @ViewChild('popTemplate', { static: true }) popTemplate;
  @Input() context: 'primary' | 'danger' | 'warning' = 'danger';
  @Input() popoverMessage: any;
  @Input() cancelButton: boolean = true;

  constructor() {}

  ngOnInit() {}
}
